import Vue from "vue";
import Vuex from "vuex";
import request from "@/router/request.js";
import requestV2 from "@/router/requestV2.js";

Vue.use(Vuex);

/**
 * Função auxiliar para mapear a resposta do backend para o formato do frontend
 */
function mapUserData(backendUser, platformName = "") {
  return {
    id: backendUser.id,
    email: backendUser.email,
    nome_usuario: backendUser.name,
    nome_instituicao: platformName,
    codigo_perfil: backendUser.codigo_perfil,
    is_admin: backendUser.is_admin ? 1 : 0,
  };
}

export default new Vuex.Store({
  state: {
    auth: {
      user: null,
      token: localStorage.getItem("token") || null,
      isAuthenticated: !!localStorage.getItem("token"),
    },
  },

  getters: {
    currentUser: (state) => state.auth.user,
    isAuthenticated: (state) => state.auth.isAuthenticated,
    userRole: (state) =>
      state.auth.user ? state.auth.user.codigo_perfil : null,
    isSystemAdmin: (state) =>
      state.auth.user ? state.auth.user.is_admin === 1 : false,
    userName: (state) => (state.auth.user ? state.auth.user.nome_usuario : ""),
    userEmail: (state) => (state.auth.user ? state.auth.user.email : ""),
    userInstitution: (state) =>
      state.auth.user ? state.auth.user.nome_instituicao : "",
  },

  mutations: {
    SET_USER(state, user) {
      state.auth.user = user;
      state.auth.isAuthenticated = !!user;
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        localStorage.removeItem("user");
      }
    },

    SET_TOKEN(state, token) {
      state.auth.token = token;
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    },

    LOGOUT(state) {
      state.auth.user = null;
      state.auth.token = null;
      state.auth.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },

    RESTORE_USER(state) {
      const userJson = localStorage.getItem("user");
      if (userJson) {
        try {
          state.auth.user = JSON.parse(userJson);
          state.auth.isAuthenticated = true;
        } catch (error) {
          console.error("Erro ao restaurar usuário do localStorage:", error);
          localStorage.removeItem("user");
        }
      }
    },
  },

  actions: {
    async fetchUserData({ commit, state }) {
      const token = state.auth.token || localStorage.getItem("token");

      if (!token) {
        throw new Error("Token não encontrado");
      }

      const userJson = localStorage.getItem("user");
      if (userJson) {
        try {
          const user = JSON.parse(userJson);
          commit("SET_USER", user);
          return user;
        } catch (error) {
          console.error(
            "[fetchUserData] Erro ao parsear usuário do localStorage:",
            error,
          );
        }
      }

      try {
        const response = await requestV2.post("/users/usuario/dados");
        const userData = response.data;

        const user = {
          id: userData.id,
          email: userData.email,
          nome_usuario: userData.name,
          nome_instituicao: userData.nome_instituicao || "",
          codigo_perfil: userData.codigo_perfil,
          is_admin: userData.is_admin ? 1 : 0,
          env: userData.env,
        };

        commit("SET_USER", user);
        return user;
      } catch (error) {
        console.error(
          "[fetchUserData] Erro ao buscar dados do usuário:",
          error.response?.status,
          error.message,
        );
        throw error;
      }
    },

    async login({ commit }, { email, password }) {
      try {
        const response = await requestV2.post("/users/login", {
          username: email,
          password: password,
        });

        const token = response.data.token;

        const user = mapUserData(
          response.data.user,
          response.data.platform?.platformName || "",
        );

        if (user.codigo_perfil !== 1 && user.codigo_perfil !== 2) {
          commit("LOGOUT");
          throw new Error("Perfil não autorizado para login tradicional");
        }

        commit("SET_TOKEN", token);
        commit("SET_USER", user);
        return user;
      } catch (error) {
        commit("LOGOUT");
        throw error;
      }
    },

    async loginLti({ commit }, { ltikToken }) {
      try {
        const response = await request.post("/asas/verificarUsuarioLti", {
          ltikToken: ltikToken,
        });

        const token = response.data.token;

        const user = mapUserData(
          response.data.user,
          response.data.platform?.platformName || "",
        );

        if (user.codigo_perfil !== 8) {
          commit("LOGOUT");
          throw new Error("Perfil não autorizado para login via LTI");
        }

        commit("SET_TOKEN", token);
        commit("SET_USER", user);
        return user;
      } catch (error) {
        console.error("[loginLti] Erro no login LTI:", error);
        commit("LOGOUT");
        throw error;
      }
    },

    async logout({ commit }) {
      try {
        await requestV2.post("/users/usuario/logout", {});
      } catch (error) {
        console.error("[logout] Erro ao revogar token no backend:", error);
      } finally {
        commit("LOGOUT");
      }
    },
  },

  modules: {},
});
